import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VApp,[_c('div',{staticClass:"page-container"},[_c('DefaultHeader'),_vm._v(" "),_c(VMain,[_c('nuxt')],1),_vm._v(" "),_c('UserProfileRegistration'),_vm._v(" "),_c('Footer')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }